const APP = {
  $body: null,
  $window: null,
  $footer: null,
  $header: null,
  viewport: {
    isMobile: null,
  },

  init: () => {
    APP.$window = $(window);
    APP.$footer = $('.footer');
    APP.$header = $('.header-inner');

    APP.domReady();
    APP.viewportInit();
    APP.windowResize();
  },

  domReady: () => {
    $(document).ready(() => {
      $('#preloader').fadeOut(500, () => {
        APP.$body = $('body').addClass('is-ready');
        APP.tooltipInit();
        APP.collapseInit();
      });
    });
  },

  viewportInit: () => {
    APP.viewport.isMobile = window.matchMedia('(max-width: 767px)').matches;
  },

  windowResize: () => {
    APP.$window.resize(() => {
      if (window.matchMedia('(max-width: 767px)').matches && !APP.viewport.isMobile) {
        APP.viewport.isMobile = true;
      }
      if (!window.matchMedia('(max-width: 767px)').matches && APP.viewport.isMobile) {
        APP.viewport.isMobile = false;
      }
    });
  },

  tooltipInit: () => {
    $('[data-toggle="tooltip"]').tooltip();
    $('.js-tooltip').tooltip({
      trigger: 'click',
      html: true,
      template: '<div class="tooltip tooltip--custom" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });

    // TODO: fix prevent click for link outwrap
    APP.$body.on('click', '.js-tooltip', (e) => {
      e.preventDefault();
    });
  },

  tooltipHide: () => {
    $('.js-tooltip').tooltip('hide');
  },

  collapseInit: () => {
    APP.$body.on('click', '.js-collapse-btn', function toggleCollapse(e) {
      e.preventDefault();
      const $row = $(this).closest('.table-flex__row');

      if ($row.length) {
        $row.toggleClass('is-open');
      }
    });

    // event listen for collapse - for close tooltip
    $('.js-collapse-content').on('hide.bs.collapse show.bs.collapse', () => {
      APP.tooltipHide();
    });
  },
};

export default APP;



// WEBPACK FOOTER //
// ./src/scripts/components/app/index.js